var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3101,
    cy: 20.9995,
    r: 20.5952,
    fill: "#19191B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3101,
    cy: 20.9995,
    r: 20.0952,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3815 17.7376V15.8376C23.3815 15.0143 23.5815 14.571 24.9815 14.571L26.7148 14.571V11.4043H24.0482C20.7148 11.4043 19.3815 13.4943 19.3815 15.8376V17.7376H16.7148V20.9043H19.3815L19.3815 30.4043H23.3815L23.3815 20.9043H26.3148L26.7148 17.7376H23.3815Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8815 17.7376V18.2376H23.3815H26.1477L25.874 20.4043H23.3815H22.8815V20.9043L22.8815 29.9043H19.8815L19.8815 20.9043V20.4043H19.3815H17.2148V18.2376H19.3815H19.8815V17.7376V15.8376C19.8815 14.7559 20.189 13.7807 20.8329 13.0807C21.4692 12.3888 22.4907 11.9043 24.0482 11.9043L26.2148 11.9043V14.071L24.9815 14.071C24.2641 14.071 23.6874 14.1765 23.3121 14.533C22.922 14.9037 22.8815 15.4191 22.8815 15.8376V17.7376Z",
    stroke: "white",
    strokeOpacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.5e3c6799807542d2d512180e2cd5f42c.svg";
export { ForwardRef as ReactComponent };